module.exports = __webpack_public_path__ + "a6d512dddd4b8310e68ec824f7b7ef57.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/file.png
// module id = 661
// module chunks = 0